export const FILTER_OUT_THRESHOLD_IN_SECONDS = 90;

export const ARRIVING_THRESHOLD_IN_MS = 60 * 1000;
export const DUE_MINS_THRESHOLD = 60;
